import { render, staticRenderFns } from "./ContentEditable.vue?vue&type=template&id=89393be6&"
import script from "./ContentEditable.vue?vue&type=script&lang=js&"
export * from "./ContentEditable.vue?vue&type=script&lang=js&"
import style0 from "./ContentEditable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports